import fridayReporter from "@/utils/friday";
import IC_VOICE_PAGE from "../assets/common/ic_voice_page.svg?react";
import "./Header.css";
import Tooltip from "@/component/Tooltip";
import { useNavigate } from "react-router-dom";

function HeaderVoice() {
  const navigate = useNavigate();

  const navigateVoicePage = () => {
    fridayReporter.pushData({
      eventCode: 'HomePage_VoiceFiles'
    })
    navigate("/voice");
  };

  return (
    <Tooltip
      content={"发言人声纹库"}
      placement={"bottom"}
      builtinPlacements={{
        bottom: {
          points: ["tc", "bc"],
          offset: [0, -5], // 下方间隔为7px
        },
      }}
    >
      <IC_VOICE_PAGE
        className="w-8 h-8 mr-6 cursor-pointer no_drag"
        onClick={navigateVoicePage}
      ></IC_VOICE_PAGE>
    </Tooltip>
  );
}

export default HeaderVoice;
